export default __webpack_public_path__ + "static/media/sustentabilidade-icon.c6fc6cf5.svg";